var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1.5H11C11.8284 1.5 12.5 2.17157 12.5 3V13.5H2C1.17157 13.5 0.5 12.8284 0.5 12V3C0.5 2.17157 1.17157 1.5 2 1.5ZM2.5 4H6.5V7.5H2.5V4ZM8 4.25H10.75V5H8V4.25ZM8 6.25H10.75V7H8V6.25ZM2.5 9.25H10.75V10H2.5V9.25ZM2.5 11H8V11.75H2.5V11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 5.25H14.25C14.6642 5.25 15 5.58579 15 6V12C15 12.8284 14.3284 13.5 13.5 13.5H13.25V5.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.ab42f0e1dccfecad2815cfead446b57e.svg";
export { ForwardRef as ReactComponent };